// ----------------------------------------------------------------------------
// Snippet: Header menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--header-cards';
var CAROUSEL_CLASS = 'carousel--header-cards';
var CAROUSEL_SECTION_SELECTOR = '.header-cards';
var CAROUSEL_SECTION_CLASS = 'header-cards';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));
  element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
    slidesPerView: 3.4,
    spaceBetween: 2,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.
    keyboard: true,
    observer: true,
    observeParents: true,
    a11y: {
      slideRole: null
    },
    breakpoints: {
      // when window width is >= 768px
      768: {
        slidesPerView: 4.1
      }
    },
    pagination: {
      el: "".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index),
      clickable: true,
      renderBullet: function renderBullet(bulletIndex, className) {
        var isActive = this.activeIndex === bulletIndex ? 'aria-current="true"' : '';
        return "<span type=\"button\" tabindex=\"0\" class=\"".concat(className, "\" ").concat(isActive, "></span>");
      }
    },
    on: {
      slideChange() {
        var bullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
        bullets.forEach((bullet, bulletIndex) => {
          if (bulletIndex === swiper.activeIndex) {
            bullet.setAttribute('aria-current', 'true');
          } else {
            bullet.removeAttribute('aria-current');
          }
        });
      }
    }
  });

  // Move to corresponding slide when Enter is pressed into pagination bullet
  var paginationBullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
  paginationBullets.forEach((bullet, bulletIndex) => {
    bullet.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // prevent scrolling for space
        swiper.slideTo(bulletIndex);
      }
    });
  });
});